import { render } from "./EditOrganisationDailyReport.vue?vue&type=template&id=4ffef59c"
import script from "./EditOrganisationDailyReport.vue?vue&type=script&lang=js"
export * from "./EditOrganisationDailyReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__